import { StoreModule } from '@ngrx/store';
import { ClientsFeatureKey } from './clients-feature-key';
import { clientsReducer } from './clients.reducer';

export * from './clients-feature-key';
export * from './clients.actions';
export * from './clients.effects';
export * from './clients.reducer';
export * from './clients.selectors';

export const ClientsStoreModule = StoreModule.forFeature(
  ClientsFeatureKey,
  clientsReducer
);
